var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crm-dialog-title"},[_vm._t("title",function(){return [_c('strong',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]}),_vm._t("subtitle",function(){return [_c('span',{staticClass:"subtitle",style:(_vm.subStyle)},[_vm._v(_vm._s(_vm.subtitle))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }